import { registerPlugin } from "@capacitor/core"
import type { GoogleAuthPlugin } from "./definitions"
import { GoogleAuthWeb } from "./web"

export const GoogleAuth = registerPlugin<GoogleAuthPlugin>("GoogleAuth", {
	web: () => new GoogleAuthWeb(),
})
